import type { TrustIDOAuthConfig } from "./types";
import { TrustIDSignIn } from "./TrustIDSignIn";

export { TrustIDSignIn } from "./TrustIDSignIn";
export { retrieveAndClearAuthParams } from "./oauth";
export type { TrustIDOAuthConfig } from "./types";

// Capture currentScript immediately (it's null inside event listeners)
const currentScript = document.currentScript as HTMLScriptElement | null;

function readConfig(): TrustIDOAuthConfig | null {
  if (!currentScript) return null;

  const clientId = currentScript.getAttribute("data-client-id");
  const redirectUri = currentScript.getAttribute("data-redirect-uri");
  const authEndpoint = currentScript.getAttribute(
    "data-authorization-endpoint"
  );

  if (!clientId || !redirectUri || !authEndpoint) return null;

  const config: TrustIDOAuthConfig = {
    client_id: clientId,
    redirect_uri: redirectUri,
    authorization_endpoint: authEndpoint,
  };

  const scope = currentScript.getAttribute("data-scope");
  if (scope) config.scope = scope;

  const theme = currentScript.getAttribute("data-theme");
  if (theme === "filled" || theme === "outline") config.theme = theme;

  const size = currentScript.getAttribute("data-size");
  if (size === "standard" || size === "large") config.size = size;

  const text = currentScript.getAttribute("data-text");
  if (text) config.text = text;

  const width = currentScript.getAttribute("data-width");
  if (width === "auto" || width === "full") config.width = width;

  const nonce = currentScript.getAttribute("data-nonce");
  if (nonce) config.nonce = nonce;

  const container = currentScript.getAttribute("data-container");
  if (container) config.container = container;

  const idpHint = currentScript.getAttribute("data-idp-hint");
  if (idpHint) config.idp_hint = idpHint;

  return config;
}

function autoInit(): void {
  const config = readConfig();
  if (!config) return;
  TrustIDSignIn.init(config, currentScript);
}

// Expose global API
(window as unknown as Record<string, unknown>).TrustIDSignIn = TrustIDSignIn;

// Auto-initialize from data attributes
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", autoInit);
} else {
  autoInit();
}
